import {RECAPTCHA_LANGUAGES} from "../constants/languages";

export const getRecaptchaLang = (lang: string | undefined): string => {
  if (!lang) {
    return RECAPTCHA_LANGUAGES.JA;
  }
  
  const langMap: Record<string, string> = {
    ja: RECAPTCHA_LANGUAGES.JA,
    tw: RECAPTCHA_LANGUAGES.TW,
    en: RECAPTCHA_LANGUAGES.EN,
  };
  
  return langMap[lang] ?? RECAPTCHA_LANGUAGES.JA;
};